import { lazy } from "react";

export const SectionPage = lazy(() => import("./sectionPage"));
